/**
 * File groups (docs/user-flow.md §6): a client's files, organised.
 *
 * The wire shapes the `/file-groups` endpoints answer with. Ids are strings on
 * the wire (backend `services/ids.ts`); the two timestamps arrive as ISO
 * strings because `res.json` serialises the Date.
 */
import { z } from 'zod';
import { fileStatusSchema } from './enums';
import { moduleOrDefaultSchema } from './modules';

export const fileGroupRecordSchema = z.object({
	pkFileGroupId: z.string(),
	fkClientId: z.string(),
	module: moduleOrDefaultSchema,
	name: z.string(),
	fileCount: z.number(),
	createdAt: z.string(),
	updatedAt: z.string(),
});

export const fileGroupMemberSchema = z.object({
	pkFileId: z.string(),
	originalName: z.string(),
	status: fileStatusSchema,
});

/** A group plus the files it holds — what the detail view reads. */
export const fileGroupDetailSchema = fileGroupRecordSchema.extend({
	files: z.array(fileGroupMemberSchema),
});

export type FileGroupRecord = z.infer<typeof fileGroupRecordSchema>;
export type FileGroupMember = z.infer<typeof fileGroupMemberSchema>;
export type FileGroupDetail = z.infer<typeof fileGroupDetailSchema>;
